/**
 * OSVA header logo switch.
 *
 * Reads the JSON config written by snippets/osva-head.liquid and adds the
 * "mark only" image next to Horizon's own header logo. Modes:
 *  - full:    Horizon logo only (this script does nothing)
 *  - mark:    mark image only
 *  - compact: full logo at the top of the page, mark once the page is scrolled
 *
 * Re-applies itself when the theme editor reloads the header section.
 */
(function () {
  const configElement = document.getElementById('osva-header-config');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }

  if (!config || !config.markUrl || config.mode === 'full') return;

  let scrollHandler = null;
  let ticking = false;

  function header() {
    return document.getElementById('header-component');
  }

  function updateCompact() {
    const element = header();
    if (!element) return;
    const threshold = Math.max(80, element.offsetHeight * 1.5);
    if (window.scrollY > threshold) {
      element.setAttribute('data-osva-compact', '');
    } else {
      element.removeAttribute('data-osva-compact');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      updateCompact();
    });
  }

  function apply() {
    const element = header();
    if (!element) return;
    const logoLink = element.querySelector('.header-logo');
    if (!logoLink) return;

    element.setAttribute('data-osva-logo-mode', config.mode);

    if (!logoLink.querySelector('.osva-header-mark')) {
      const img = document.createElement('img');
      img.className = 'osva-header-mark';
      img.src = config.markUrl;
      img.alt = config.alt || '';
      img.decoding = 'async';
      if (config.markWidth && config.markHeight) {
        img.width = config.markWidth;
        img.height = config.markHeight;
      }
      img.style.setProperty('--osva-mark-height', `${config.height || 36}px`);
      img.style.setProperty('--osva-mark-height-mobile', `${config.heightMobile || 28}px`);
      logoLink.appendChild(img);
    }

    if (config.mode === 'compact') {
      if (!scrollHandler) {
        scrollHandler = onScroll;
        window.addEventListener('scroll', scrollHandler, { passive: true });
      }
      updateCompact();
    } else if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement && event.target.querySelector('#header-component')) {
      apply();
    }
  });
})();
